import { render, staticRenderFns } from "./FeedEdit.vue?vue&type=template&id=93b6fee4&scoped=true"
import script from "./FeedEdit.vue?vue&type=script&lang=js"
export * from "./FeedEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b6fee4",
  null
  
)

export default component.exports